import React from 'react';
import { withStyles, withTheme } from '@material-ui/core/styles';
import { Query } from 'react-apollo';
import classes from './categories.module.scss';
import { Link } from '@reach/router';
import { GET_CATEGORIES } from '../../queries';
import { CircularProgress } from '@material-ui/core';
import Section from '../section/section';

const Categories = () => {
  return (
    <div className={classes.categories}>
      <Query query={GET_CATEGORIES}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ textAlign: 'center' }}>
                <CircularProgress />
              </div>
            );
          }
          if (error) {
            return <div>Error fetching products</div>;
          }
          const { categories } = data;
          return (
            <Section title={'Категорії'} count={categories.length}>
              <ul>
                {categories.map(
                  (category: { label: string; value: string }, key: number) => (
                    <li key={key}>
                      <Link to={category.value}>{category.label}</Link>
                    </li>
                  )
                )}
              </ul>
            </Section>
          );
        }}
      </Query>
    </div>
  );
};

export default withTheme()(withStyles(classes as any)(Categories));
